import React, { useRef, useEffect } from "react";
import { useLanding } from "../../context/LandingContext";

import loading from "./assets/loading.mp4";

const Loading = () => {
    const { showLanding } = useLanding();
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 2;
        }
    }, []);

    // Do not render Loading if Landing screen is currently playing
    if (showLanding) {
        return null;
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
                backgroundColor: "#000000",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9999,
                margin: 0,
                padding: 0,
                pointerEvents: "none",
                userSelect: "none",
            }}
        >
            {/* Small container for the video */}
            <div
                style={{
                    width: "150px",
                    height: "150px",
                    pointerEvents: "none",
                    userSelect: "none",
                }}
            >
                <video
                    ref={videoRef}
                    src={loading}
                    autoPlay
                    loop
                    muted
                    playsInline
                    disablePictureInPicture
                    disableRemotePlayback
                    controlsList="nodownload nofullscreen noremoteplayback"
                    tabIndex={-1}
                    onContextMenu={(e) => e.preventDefault()}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        display: "block",
                        pointerEvents: "none",
                        userSelect: "none",
                    }}
                />
            </div>
        </div>
    );
};

export default Loading;
